export const ADD_COINS_MINTED_EVENT = 'ADD_COINS_MINTED_EVENT';

function coinsMintedEventReducer (state = [], action) {
  switch (action.type) {
    case ADD_COINS_MINTED_EVENT:
      return [...state, action.payload];
    default:
      return state;
  }
}

export default coinsMintedEventReducer;




// WEBPACK FOOTER //
// ./src/storage/CoinsMintedEventReducer.js